import { useContext } from 'react';
import { ThemeContext } from '../contexts';

/**
 * Custom hook to access the current theme configuration
 * @returns {object} Current theme configuration
 * @throws {Error} If used outside of ThemeProvider
 */
export default function useTheme() {
  const context = useContext(ThemeContext);
  
  if (context === undefined) {
    throw new Error('useTheme must be used within a ThemeProvider');
  }
  
  return context;
}

